/* 👻🚨👻🚨👻 Let op! This code has been auto generated, so best not to touch it 👻🚨👻🚨👻 */
import * as Types from '../types';

import type { FetchOptions } from "../fetcher/fetcher.types"
import { useQuery, useSuspenseQuery, useInfiniteQuery, useSuspenseInfiniteQuery, UseQueryOptions, UseSuspenseQueryOptions, UseInfiniteQueryOptions, InfiniteData, UseSuspenseInfiniteQueryOptions } from '@tanstack/react-query';
import { fetcher } from '../fetcher/index';
export type UserCoinBalanceQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type UserCoinBalanceQuery = { __typename?: 'Query', userBalance: { __typename?: 'UserBalance', balance: number } };

export type CoinEarnAmountsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type CoinEarnAmountsQuery = { __typename?: 'Query', coinEarnAmounts: { __typename?: 'CoinsEarnAmountResponse', amounts?: Array<{ __typename?: 'CoinEarnAmount', earnType: Types.CoinEarnType, amount: number }> | null } };



export const UserCoinBalanceDocument = /*#__PURE__*/ `
    query userCoinBalance {
  userBalance {
    balance
  }
}
    `;

export const useUserCoinBalanceQuery = <
      TData = UserCoinBalanceQuery,
      TError = unknown
    >(
      variables?: UserCoinBalanceQueryVariables,
      options?: Omit<UseQueryOptions<UserCoinBalanceQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<UserCoinBalanceQuery, TError, TData>['queryKey'] },
      headers?: Headers, fetchOptions?: FetchOptions
    ) => {
    
    return useQuery<UserCoinBalanceQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['userCoinBalance'] : ['userCoinBalance', variables],
    queryFn: fetcher<UserCoinBalanceQuery, UserCoinBalanceQueryVariables>(UserCoinBalanceDocument, variables, headers, fetchOptions),
    ...options
  }
    )};

useUserCoinBalanceQuery.document = UserCoinBalanceDocument;

useUserCoinBalanceQuery.getKey = (variables?: UserCoinBalanceQueryVariables) => variables === undefined ? ['userCoinBalance'] : ['userCoinBalance', variables];

useUserCoinBalanceQuery.rootKey = 'userCoinBalance';

export const useSuspenseUserCoinBalanceQuery = <
      TData = UserCoinBalanceQuery,
      TError = unknown
    >(
      variables?: UserCoinBalanceQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<UserCoinBalanceQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<UserCoinBalanceQuery, TError, TData>['queryKey'] },
      headers?: Headers, fetchOptions?: FetchOptions
    ) => {
    
    return useSuspenseQuery<UserCoinBalanceQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['userCoinBalanceSuspense'] : ['userCoinBalanceSuspense', variables],
    queryFn: fetcher<UserCoinBalanceQuery, UserCoinBalanceQueryVariables>(UserCoinBalanceDocument, variables, headers, fetchOptions),
    ...options
  }
    )};

useSuspenseUserCoinBalanceQuery.document = UserCoinBalanceDocument;

useSuspenseUserCoinBalanceQuery.getKey = (variables?: UserCoinBalanceQueryVariables) => variables === undefined ? ['userCoinBalanceSuspense'] : ['userCoinBalanceSuspense', variables];

useSuspenseUserCoinBalanceQuery.rootKey = 'userCoinBalance';

export const useInfiniteUserCoinBalanceQuery = <
      TData = InfiniteData<UserCoinBalanceQuery>,
      TError = unknown
    >(
      variables: UserCoinBalanceQueryVariables,
      options: Omit<UseInfiniteQueryOptions<UserCoinBalanceQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<UserCoinBalanceQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<UserCoinBalanceQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['userCoinBalance.infinite'] : ['userCoinBalance.infinite', variables],
      queryFn: (metaData) => fetcher<UserCoinBalanceQuery, UserCoinBalanceQueryVariables>(UserCoinBalanceDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteUserCoinBalanceQuery.getKey = (variables?: UserCoinBalanceQueryVariables) => variables === undefined ? ['userCoinBalance.infinite'] : ['userCoinBalance.infinite', variables];

useInfiniteUserCoinBalanceQuery.rootKey = 'userCoinBalance.infinite';

export const useSuspenseInfiniteUserCoinBalanceQuery = <
      TData = InfiniteData<UserCoinBalanceQuery>,
      TError = unknown
    >(
      variables: UserCoinBalanceQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<UserCoinBalanceQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<UserCoinBalanceQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<UserCoinBalanceQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['userCoinBalance.infiniteSuspense'] : ['userCoinBalance.infiniteSuspense', variables],
      queryFn: (metaData) => fetcher<UserCoinBalanceQuery, UserCoinBalanceQueryVariables>(UserCoinBalanceDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteUserCoinBalanceQuery.getKey = (variables?: UserCoinBalanceQueryVariables) => variables === undefined ? ['userCoinBalance.infiniteSuspense'] : ['userCoinBalance.infiniteSuspense', variables];

useSuspenseInfiniteUserCoinBalanceQuery.rootKey = 'userCoinBalance.infinite';


useUserCoinBalanceQuery.fetcher = (variables?: UserCoinBalanceQueryVariables, options?: RequestInit['headers'], fetchOptions?: FetchOptions) => fetcher<UserCoinBalanceQuery, UserCoinBalanceQueryVariables>(UserCoinBalanceDocument, variables, options, fetchOptions);

export const CoinEarnAmountsDocument = /*#__PURE__*/ `
    query coinEarnAmounts {
  coinEarnAmounts {
    amounts {
      earnType
      amount
    }
  }
}
    `;

export const useCoinEarnAmountsQuery = <
      TData = CoinEarnAmountsQuery,
      TError = unknown
    >(
      variables?: CoinEarnAmountsQueryVariables,
      options?: Omit<UseQueryOptions<CoinEarnAmountsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CoinEarnAmountsQuery, TError, TData>['queryKey'] },
      headers?: Headers, fetchOptions?: FetchOptions
    ) => {
    
    return useQuery<CoinEarnAmountsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['coinEarnAmounts'] : ['coinEarnAmounts', variables],
    queryFn: fetcher<CoinEarnAmountsQuery, CoinEarnAmountsQueryVariables>(CoinEarnAmountsDocument, variables, headers, fetchOptions),
    ...options
  }
    )};

useCoinEarnAmountsQuery.document = CoinEarnAmountsDocument;

useCoinEarnAmountsQuery.getKey = (variables?: CoinEarnAmountsQueryVariables) => variables === undefined ? ['coinEarnAmounts'] : ['coinEarnAmounts', variables];

useCoinEarnAmountsQuery.rootKey = 'coinEarnAmounts';

export const useSuspenseCoinEarnAmountsQuery = <
      TData = CoinEarnAmountsQuery,
      TError = unknown
    >(
      variables?: CoinEarnAmountsQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<CoinEarnAmountsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<CoinEarnAmountsQuery, TError, TData>['queryKey'] },
      headers?: Headers, fetchOptions?: FetchOptions
    ) => {
    
    return useSuspenseQuery<CoinEarnAmountsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['coinEarnAmountsSuspense'] : ['coinEarnAmountsSuspense', variables],
    queryFn: fetcher<CoinEarnAmountsQuery, CoinEarnAmountsQueryVariables>(CoinEarnAmountsDocument, variables, headers, fetchOptions),
    ...options
  }
    )};

useSuspenseCoinEarnAmountsQuery.document = CoinEarnAmountsDocument;

useSuspenseCoinEarnAmountsQuery.getKey = (variables?: CoinEarnAmountsQueryVariables) => variables === undefined ? ['coinEarnAmountsSuspense'] : ['coinEarnAmountsSuspense', variables];

useSuspenseCoinEarnAmountsQuery.rootKey = 'coinEarnAmounts';

export const useInfiniteCoinEarnAmountsQuery = <
      TData = InfiniteData<CoinEarnAmountsQuery>,
      TError = unknown
    >(
      variables: CoinEarnAmountsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<CoinEarnAmountsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<CoinEarnAmountsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<CoinEarnAmountsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['coinEarnAmounts.infinite'] : ['coinEarnAmounts.infinite', variables],
      queryFn: (metaData) => fetcher<CoinEarnAmountsQuery, CoinEarnAmountsQueryVariables>(CoinEarnAmountsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteCoinEarnAmountsQuery.getKey = (variables?: CoinEarnAmountsQueryVariables) => variables === undefined ? ['coinEarnAmounts.infinite'] : ['coinEarnAmounts.infinite', variables];

useInfiniteCoinEarnAmountsQuery.rootKey = 'coinEarnAmounts.infinite';

export const useSuspenseInfiniteCoinEarnAmountsQuery = <
      TData = InfiniteData<CoinEarnAmountsQuery>,
      TError = unknown
    >(
      variables: CoinEarnAmountsQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<CoinEarnAmountsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<CoinEarnAmountsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<CoinEarnAmountsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['coinEarnAmounts.infiniteSuspense'] : ['coinEarnAmounts.infiniteSuspense', variables],
      queryFn: (metaData) => fetcher<CoinEarnAmountsQuery, CoinEarnAmountsQueryVariables>(CoinEarnAmountsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteCoinEarnAmountsQuery.getKey = (variables?: CoinEarnAmountsQueryVariables) => variables === undefined ? ['coinEarnAmounts.infiniteSuspense'] : ['coinEarnAmounts.infiniteSuspense', variables];

useSuspenseInfiniteCoinEarnAmountsQuery.rootKey = 'coinEarnAmounts.infinite';


useCoinEarnAmountsQuery.fetcher = (variables?: CoinEarnAmountsQueryVariables, options?: RequestInit['headers'], fetchOptions?: FetchOptions) => fetcher<CoinEarnAmountsQuery, CoinEarnAmountsQueryVariables>(CoinEarnAmountsDocument, variables, options, fetchOptions);
